export default {"src":"/uk/_next/static/media/healthcareIcon.3413f75f.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};